import config from '../config'
import { authorizedFetch } from '../utils/auth'
import { checkStatus } from '../utils/fetch'
import { updateAccount, logout, updateInactiveEvents, updateReceiveNewsletter } from './auth'
import { fetchLocations } from './locations'

export const SHOW_ACCOUNT_MODAL = 'SHOW_ACCOUNT_MODAL'
export const CLOSE_ACCOUNT_MODAL = 'CLOSE_ACCOUNT_MODAL'

export const SHOW_RESEND_EMAIL_MODAL = 'SHOW_RESEND_EMAIL_MODAL'
export const CLOSE_RESEND_EMAIL_MODAL = 'CLOSE_RESEND_EMAIL_MODAL'
export const HANDLE_INACTIVE_EVENTS_SWITCH = 'HANDLE_INACTIVE_EVENTS_SWITCH'
export const UPDATE_ACTIVE_BUILDING = 'UPDATE_ACTIVE_BUILDING'
export const UPDATE_COMMUNICATION_PREFERENCES = 'UPDATE_COMMUNICATION_PREFERENCES'

export const showAccountModal = () => ({
  type: SHOW_ACCOUNT_MODAL
})

export const closeAccountModal = () => ({
  type: CLOSE_ACCOUNT_MODAL
})

export const showResendEmailModal = () => ({
  type: SHOW_RESEND_EMAIL_MODAL
})

export const closeResendEmailModal = () => ({
  type: CLOSE_RESEND_EMAIL_MODAL
})

export const fetchAccountDetails = (userId) => (dispatch) => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'users/profile/' + userId, {
    headers: headers,
    cache: 'default',
    method: 'GET'
  })
    .then(checkStatus)
    .then((response) => response.json())
    .then((response) => dispatch(updateAccount(response)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const handleInactiveEventsSwitch = (userId, allowInactiveEvents) => (dispatch) => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'users/update/' + userId, {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ showUnapprovedEvents: allowInactiveEvents })
  })
    .then(checkStatus)
    .then((response) => response.json())
    .then((response) => dispatch(updateInactiveEvents(allowInactiveEvents)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const handleReceiveNewsletterSwitch = (userId, allowReceiveNewsletter) => (dispatch) => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'users/update/' + userId, {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ receiveNewsletter: allowReceiveNewsletter })
  })
    .then(checkStatus)
    .then((response) => response.json())
    .then((response) => dispatch(updateReceiveNewsletter(allowReceiveNewsletter)))
    .catch(function(error) {
      dispatch(logout())
    })
}

/* this action post the active building into the users DB */

export const selectActiveBuilding = (userId, activeBuilding) => (dispatch) => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'users/update/' + userId, {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ activeBuilding: activeBuilding })
  })
    .then(checkStatus)
    .then((response) => response.json())
    .then((response) => dispatch(updateActiveBuilding(activeBuilding)))
    .then((response) => dispatch(fetchLocations(userId)))
    .then((response) => dispatch(fetchAccountDetails(userId)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const updateActiveBuilding = (activeBuilding) => ({
  type: UPDATE_ACTIVE_BUILDING,
  activeBuilding
})

export const selectCommunicationPreferences = (userId, communicationPreferences) => (dispatch) => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'users/update/' + userId, {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ communicationPreferences })
  })
    .then(checkStatus)
    .then((response) => response.json())
    .then((response) => dispatch(updateCommunicationPreferences(selectCommunicationPreferences)))
    .then((response) => dispatch(fetchLocations(userId)))
    .then((response) => dispatch(fetchAccountDetails(userId)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const updateCommunicationPreferences = (communicationPreferences) => ({
  type: UPDATE_COMMUNICATION_PREFERENCES,
  communicationPreferences
})



// WEBPACK FOOTER //
// ./src/actions/account.js